import { NotificationStrategy } from '../../../../shared/services/notification/workflow';

export const meStoppedIndustrializationStrategy: NotificationStrategy = {
  accept: async () => {
    throw new Error('ME_STOPPED_INDUSTRIALIZATION does not support ACCEPT action');
  },
  reject: async () => {
    throw new Error('ME_STOPPED_INDUSTRIALIZATION does not support REJECT action');
  },
};